import React, { FC, ReactNode } from 'react';
import { Util } from 'snacks-design-system';

interface IPIEComponentUtil {
  children: ReactNode;
  tag: string;
  bgColor: string;
  margin: string;
  marginTop: string;
  marginBottom: string;
  marginLeft: string;
  marginRight: string;
  marginInlineStart: string;
  marginInlineEnd: string;
  marginBlockStart: string;
  marginBlockEnd: string;
  marginX: string;
  marginY: string;
  padding: string;
  paddingTop: string;
  paddingBottom: string;
  paddingLeft: string;
  paddingRight: string;
  paddingInlineStart: string;
  paddingInlineEnd: string;
  paddingBlockStart: string;
  paddingBlockEnd: string;
  paddingX: string;
  paddingY: string;
  borderColor: string;
  borderRadius: string;
  modBorder: boolean;
  modRelative: boolean;
  className: string;
}

export const PIEComponentUtil: FC<Partial<IPIEComponentUtil>> = (props) => {
  return (
    <Util {...props}>
      <div className={props.className}> {props.children}</div>
    </Util>
  );
};
